import { takeLatest, call, put } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { setSending, unsetSending } from '../reducers/serverCommunication';
import {
  setUpdateRecommendedResourceByScoreFaluire,
  setUpdateRecommendedResourceByScoreRequest,
  setUpdateRecommendedResourceByScoreSuccess,
} from '../reducers/resourceDataReducer';

export const SAGA_UPDATE_RECOMMENDED_RESOURCE = 'SAGA_UPDATE_RECOMMENDED_RESOURCE';

export function sendUpdateRecommendedResource(payload) {
  return { type: SAGA_UPDATE_RECOMMENDED_RESOURCE, payload };
}

const handleUpdateRecommendedResource = async ({ pain, worry, mood, sleep, substance }) =>
  axiosInstance
    .put('/api/pop/resources/recommended', {
      pain,
      worry,
      mood,
      sleep,
      substance,
    })
    .then((res) => res.data);

export function* updateRecommendedResource(action) {
  yield put(setSending);
  yield put(setUpdateRecommendedResourceByScoreRequest);
  try {
    const response = yield call(handleUpdateRecommendedResource, action.payload);
    yield put(setUpdateRecommendedResourceByScoreSuccess(response));
  } catch (error) {
    yield put(setUpdateRecommendedResourceByScoreFaluire(error.response));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForUpdateRecommendedResource() {
  yield takeLatest(SAGA_UPDATE_RECOMMENDED_RESOURCE, updateRecommendedResource);
}
